// 聽牌後自動摸打的純動作決策。
//
// === 使用圖片 ===
// 無 — 只產生核心動作，不直接渲染畫面。

import { PlayerActionType, type TPlayerAction } from '@core/events';
import type { TTile } from '@core/tile';

/**
 * 瞇牌動畫結束後直接送核心動作。
 * 捨牌是否需要停在門前，由核心後續的 discard.pending / discard.committed 事件決定。
 */
export const buildTenpaiAutoTurnAction = (drawn: TTile, canHu: boolean): TPlayerAction =>
  canHu ? { type: PlayerActionType.Hu } : { type: PlayerActionType.Discard, tile: drawn };
